import { useState } from 'react'
import { Check, Copy } from 'lucide-react'
import { Button } from '@/components/ui/button'

export default function CopyButton({
  value,
  label,
  copy,
  variant = 'outline',
}: {
  value: string
  label: string
  copy: Record<string, string>
  variant?: 'default' | 'outline'
}) {
  const [copied, setCopied] = useState(false)
  const [failed, setFailed] = useState(false)
  async function copyValue() {
    try {
      await navigator.clipboard.writeText(value)
      setCopied(true)
      setFailed(false)
    } catch {
      setFailed(true)
    }
  }
  return (
    <div className="flex flex-wrap items-center gap-2">
      <Button type="button" size="sm" variant={variant} onClick={copyValue}>
        {copied ? <Check className="size-3.5" /> : <Copy className="size-3.5" />}
        {copied ? copy.copied : label}
      </Button>
      {failed && (
        <span role="alert" className="text-xs text-destructive">
          {copy.copy_failed}
        </span>
      )}
    </div>
  )
}
